var exports = {
  "D": "x04b3a21e--dcb0b4--title",
};

module.exports = exports;
